// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".datetimepicker-component,\n.datetimepicker-component input {\n  cursor: pointer;\n  z-index: 1;\n}\n.datetimepicker-component.date-grid,\n.datetimepicker-component input.date-grid {\n  display: flex;\n  align-items: center;\n}\n\n.input-group-addon.span-grid {\n  cursor: pointer;\n  margin-left: 5px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
